__turbopack_context__.v({
  "icon": "SubmenuLabel-module__v1SkpG__icon",
  "subMenuLabel": "SubmenuLabel-module__v1SkpG__subMenuLabel",
});
